import React from "react";
import ME from "../../assets/img/about.webp";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";

import "./about.css";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div
          className="about__me"
          data-aos="flip-left"
          data-aos-delay="300"
          data-aos-duration="1500"
        >
          <div className="about__me-image">
            <img loading="lazy" src={ME} alt="About Me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article
              className="about__card"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>
                {Math.abs(
                  new Date("2018-01-01").getFullYear() -
                    new Date().getFullYear()
                )}
                + Years Working
              </small>
            </article>
            {/* <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Clients</h5>
              <small>300 Worldwide</small>
            </article> */}
            <article
              className="about__card"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="100"
            >
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>15+ Completed</small>
            </article>
          </div>
          <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="150">
            Creative Front-End Developer offering{" "}
            {Math.abs(
              new Date("2018-01-01").getFullYear() - new Date().getFullYear()
            )}
            + years of experience providing high-impact web solutions.
            Experienced with all stages of the development cycle for dynamic web
            projects and also very well-versed in numerous programming
            languages. Well-versed in Scrum and Agile environment as well as in
            normal methodology as waterfall. Flexible to learn any new
            technology as well as any methods or methodologies that help improve
            work as I am focused result oriented.
          </p>
          <a
            href="#contact"
            className="btn btn-primary"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
